import React from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"

import Image from "components/image"
import NestedImage from "components/nested-image"

const ContentfulImage = ({ component, onTop, nested, crop, elRef, dataId }) => {
  const {
    image,
    altText,
    position,
    size,
    hideOnMobile,
    backgroundColor,
    useOriginalAspectRatio,
    navigationAnchor,
    minHeight,
    clickThroughUrl,
    id,
    hideOnPageLoad,
  } = component

  const images = {
    desktop: image[0],
    tablet: image.length > 2 ? image[1] : image[0],
    mobile: image.length > 2 ? image[2] : image.length > 1 ? image[1] : image[0],
  }

  const cloudinaryUrls = Object.keys(images).reduce(
    (obj, key) => ({ ...obj, [key]: images[key].secure_url }),
    {},
  )

  const aspectRatios = Object.keys(images).reduce((obj, key) => {
    const height = Math.min(useOriginalAspectRatio ? 10000 : 750, images[key].height)
    const ratio = images[key].height / height
    const width = images[key].width / ratio
    return { ...obj, [key]: height / width }
  }, {})

  const renderImage = () => (
    <Image
      hideOnPageLoad={hideOnPageLoad}
      dataExpId={dataId || id}
      id={navigationAnchor && navigationAnchor.anchorId}
      elRef={elRef}
      cloudinaryUrls={cloudinaryUrls}
      aspectRatios={aspectRatios}
      cappedHeight={!useOriginalAspectRatio}
      alt={altText}
      fullWidth={position === "Full-Width"}
      size={size}
      hideOnMobile={hideOnMobile}
    />
  )

  return (
    <ThemeProvider theme={componentThemeExtension(backgroundColor, nested, onTop)}>
      {nested && (
        <NestedImage
          hideOnPageLoad={hideOnPageLoad}
          dataExpId={dataId || id}
          crop={crop}
          cloudinaryUrls={cloudinaryUrls}
          aspectRatios={aspectRatios}
          minHeight={minHeight}
          useOriginalAspectRatio={useOriginalAspectRatio}
        />
      )}
      {!nested &&
        (clickThroughUrl ? (
          <a href={`${clickThroughUrl}`} aria-label={altText}>
            {renderImage()}
          </a>
        ) : (
          renderImage()
        ))}
    </ThemeProvider>
  )
}

export default ContentfulImage
